<!-- Region Add/Edit Modal -->
<div class="modal fade" id="kt_modal_region_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content" style="overflow: visible;">
      <div class="modal-header" id="kt_modal_region_add_edit_header">
        <h2 class="fw-bold">{{ isEditMode ? 'Edit Region' : 'Add Region' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body px-5 my-7" style="overflow: visible;">
        <form [formGroup]="regionForm" (ngSubmit)="onSubmit()">
          <div class="d-flex flex-column px-5 px-lg-10" style="overflow: visible;">

            <!-- Name -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Name</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="name"
                  placeholder="Enter region name"
                  [class.is-invalid]="name?.invalid && name?.touched"
                />
                <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                  <div *ngIf="name?.errors?.['required']">Region name is required</div>
                  <div *ngIf="name?.errors?.['minlength']">Region name must be at least 2 characters</div>
                </div>
              </div>
            </div>



          </div>
        </form>
      </div>

      <div class="modal-footer flex-center">
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isLoading || regionForm.invalid"
          (click)="onSubmit()"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm align-middle me-2"></span>
          {{ isEditMode ? 'Update Region' : 'Add Region' }}
        </button>
      </div>
    </div>
  </div>
</div>
